import { Component, DestroyRef, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OtpService, OtpLogin } from 'shared';
import { ButtonComponent, OtpFormComponent, SignupFormComponent } from 'component-library';
import { AuthenticationConfig } from 'shared';
import { NavigationService } from '../auth/navigation/navigation.service';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-otp',
  standalone: true,
  imports: [SignupFormComponent, OtpFormComponent, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './otp.component.html',
})
export class OtpComponent {
  public readonly config = inject(AuthenticationConfig);
  private readonly destroyRef = inject(DestroyRef);
  private readonly navigationService = inject(NavigationService);
  private readonly otpService = inject(OtpService);
  private readonly router = inject(Router);

  protected readonly loginError = signal(false);
  protected readonly readyForOtp = signal(false);
  protected readonly signUp = signal(false);
  protected readonly signupUrl = signal<string | undefined>(undefined);

  constructor() {
    this.signUp.set(!!this.config.otpConfig?.allowSignup);
  }

  doSignup(newUser: OtpLogin) {
    this.otpService
      .signup(newUser)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.signUp.set(false));
  }

  doSendOtpRequest(otpRequest: Partial<OtpLogin>) {
    this.otpService
      .sendOtpRequest(otpRequest)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: ({ url }) => {
          this.signupUrl.set(url);
          this.readyForOtp.set(true);
          this.loginError.set(false);
        },
        error: () => this.loginError.set(true),
      });
  }

  doLoginRequest(event: { loginUser: OtpLogin; navigateToRoot: boolean }) {
    this.otpService
      .loginRequest(event.loginUser)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          if (event.navigateToRoot) {
            this.router.navigate(['/']);
          } else {
            this.navigationService.back();
          }
        },
        error: () => this.loginError.set(true),
      });
  }

  signIn() {
    this.signUp.set(false);
    this.loginError.set(false);
    this.readyForOtp.set(false);
  }

  handleSignUp() {
    this.signUp.set(true);
    this.loginError.set(false);
  }
}
